export const ALTRU_INFO = {
  company_account_id: "altrucreative",
  api_key: "ScoroAPI_91c96ad21ac96d6"
};

export const MY_INFO = {
  company_account_id: "altrueli",
  api_key: "ScoroAPI_5ab62fe6d28c28f"
};

export const STUDIO_A_RESOURCE_ID = 9;
export const STUDIO_B_RESOURCE_ID = 10;

export const PRODUCERS_USER_GROUP_ID = "14";

export const PRODUCER_IDS = {
  1: "John Hanna",
  16: "Greg Graves",
  18: "Tom Catena",
  21: "Topper Atwood",
  23: "Charles Moffet",
  30: "Owen DePuy"
};

export const ACTIVITY_IDS = {
  "Mix Session": 252,
  "Tracking Session": 285
};
